import { create } from 'zustand';
import { useSimulationStore } from './simulationStore';

export type UserRole = 'admin' | 'manager' | 'employee' | 'customer';

export interface AuthUser {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  permissions: string[];
  glnNumbers: string[];
  language: string;
  hasChangedPassword: boolean;
}

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthUser | null;
  accessToken: string | null;
  setUser: (user: AuthUser) => void;
  setAuth: (user: AuthUser, accessToken: string) => void;
  setAccessToken: (token: string) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  accessToken: null,
  setUser: (user) => set({ isAuthenticated: true, user }),
  setAuth: (user, accessToken) => set({ isAuthenticated: true, user, accessToken }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setLoading: (isLoading) => set({ isLoading }),
  // spec-simulatie-stopt-bij-uitloggen: elk uitlogpad (knop, wachtwoordscherm, sessieverloop) komt
  // hier langs. De simulatie stopt eerst, zodat niemand ooit uitgelogd is en nog als klant werkt. Die
  // volgorde draagt ook de gebruiksmeting: AnalyticsTracker zet bij het stoppen een grendel die zijn
  // uitlog-abonnee daarna terugzet; omgekeerd zou de eerste pagina na opnieuw inloggen wegvallen.
  logout: () => {
    useSimulationStore.getState().stopSimulation();
    set({ isAuthenticated: false, user: null, accessToken: null });
  },
}));
